import { useSearchParams } from 'react-router-dom';

/**
 * True when the app is rendered inside the landing page's iframe, signalled by
 * `?embed=1` on the URL. Embedded surfaces (currently the pricing page) tweak
 * their layout — e.g. extra top padding to clear the landing's overlay nav, and
 * an explicit "logged in as" note so there's no doubt which account is acting.
 */
export function useIsEmbedded(): boolean {
  const [params] = useSearchParams();
  return params.get('embed') === '1';
}
